<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <DefectGroupForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefectGroupForm from '@/components/organisms/master/form/DefectGroupForm'

export default {
  name: 'DefectGroupPage',

  components: {
    DefectGroupForm,
  },
}
</script>
